import { timeLineTicks } from "../../Chart/ChartUtils"

export function timeLineObj (props) {
  const titleTip = (toolTipItems) => {
    const item = toolTipItems[0]
    return item.dataset.data[item.dataIndex]?.tipTitle ?? ''
  }
  const labelTip = (items) => {
    return items.dataset.data[items.dataIndex]?.tipBody ?? ''
  }
  const footerTip = (toolTipItems) => {
    //toolTipItems.forEach((item, index) => console.log (index, item))
    const item = toolTipItems[0]
    //console.log (toolTipItems[0])
    return item.dataset.data[item.dataIndex].tipFooter ?? ''
  }
  // props.chart item example:
  // { x: "2025-04-01", y: 2, tipTitle: '8000C015', tipBody: 'MDT Battery Voltage dropped below 2.20 Volts', tipFooter: '2.179 Volts', }
  const tdata2 = props?.dataProp ?? []
  const callbackParent = props
  const timeConfig = timeLineTicks([props.state.startrange, props.state.endrange])
  //console.log (tdata2)
  return ({
    defaults: {
      font: "sans-serif",
    },
    type: 'line',
    data: {
      datasets: [
        {
          data: tdata2,
          pointStyle: 'circle',
          borderWidth: 1,
          showLine: false,
          pointBackgroundColor: 'gray',
          pointRadius: 6,
          pointHoverRadius: 12,
        },
        { data: tdata2,
          type: 'bar',
          barThickness: 1,
        },
        {
          data: undefined,
          pointStyle: 'circle',
          showLine: true,
          borderColor: 'blue',
          yAxisID: "rightYaxis",
        },
        {
          data: undefined,
          pointStyle: 'crossRot',
          pointRadius: 6,
          showLine: true,
          borderColor: 'DarkRed',
          yAxisID: "rightYaxis",
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'time',
          distribution: 'linear',
          ticks: { display: true, source:'auto' },
          grid: {display: false},
          ...timeConfig,
          min: props.state.startrange,
          max: props.state.endrange,
        },
        y: {
          ticks: { display: false },
          grid: {display: false},
          display: false,
          grace: '150%',
        },
        rightYaxis: {
          display: false,
          type: 'linear',
          position: 'right',
          grid: {display: false},
          grace: '50%',
        }
      },
      onClick: function (event, elements) {
                  const clickedElement = elements[0];
                  if (clickedElement) {
                    const datasetIndex = clickedElement.index;
                    //console.log (event, elements, datasetIndex)
                    callbackParent.deviceHist =tdata2[datasetIndex]?.tipTitle
                    setTimeout(()=>callbackParent.clickedIndex(datasetIndex), 10)
                  }
      },
      plugins: {
        tooltip: {
          displayColors: false,
          callbacks: {
            title: titleTip,
            label: labelTip, 
            footer: footerTip,
          }
        },
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: props?.title ?? "All site alarms"
        }
      },
    },
  })
}
